import React from 'react';
import './CompanyPage.css';

const principles = [
  { title: 'A sense of place', text: 'The most memorable spaces begin with their setting: the rhythm of a street, the softness of the light, and the character of a neighbourhood.' },
  { title: 'Considered discovery', text: 'We bring architecture, location and the small details of daily life into one thoughtful property search.' },
  { title: 'A quieter point of view', text: 'QubeYards is a design-minded property journal for people who believe the right address can change how a place feels.' },
];

export default function CompanyPage({ onNavigateToPage }) {
  return (
    <main className="company-page">
      <section className="company-hero">
        <div className="company-hero-copy">
          <p className="company-eyebrow">AN INDEPENDENT PROPERTY JOURNAL</p>
          <h1>About QubeYards</h1>
          <p className="company-intro">QubeYards sees real estate through the lens of architecture, atmosphere and everyday life. We bring together distinctive homes and remarkable spaces in a more considered editorial experience.</p>
          <div className="company-hero-actions">
            <button type="button" className="company-primary-btn" onClick={() => onNavigateToPage?.('properties')}>Explore properties</button>
            <button type="button" className="company-secondary-btn" onClick={() => onNavigateToPage?.('contact')}>Contact us</button>
          </div>
        </div>
      </section>

      <section className="company-grid" aria-label="How QubeYards works">
        {principles.map((item) => <article className="company-card" key={item.title}><h2>{item.title}</h2><p>{item.text}</p></article>)}
      </section>

      <section className="company-footer-banner">
        <div>
          <p className="company-eyebrow">A more considered search</p>
          <h2>A considered point of view on the places that move us.</h2>
        </div>
        <button type="button" className="company-primary-btn" onClick={() => onNavigateToPage?.('properties')}>Browse properties</button>
      </section>
    </main>
  );
}
